(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.tf-rv:not(.is-in)');
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){Array.prototype.forEach.call(els,function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target)}})
    },{threshold:0.12,rootMargin:'0px 0px -8% 0px'});
    Array.prototype.forEach.call(els,function(e){io.observe(e)});
  }

  function faq(root){
    var qs=(root||document).querySelectorAll('.tf-q:not([data-tf-ready])');
    Array.prototype.forEach.call(qs,function(q){
      q.setAttribute('data-tf-ready','1');
      var btn=q.querySelector('.tf-q__b');
      var pan=q.querySelector('.tf-q__p');
      if(!btn||!pan)return;
      if(q.classList.contains('is-open')){pan.style.height='auto'}
      btn.addEventListener('click',function(){
        var open=q.classList.contains('is-open');
        var group=q.closest('.tf-faq__list');
        if(group){
          Array.prototype.forEach.call(group.querySelectorAll('.tf-q.is-open'),function(o){
            if(o===q)return;
            var op=o.querySelector('.tf-q__p');
            op.style.height=op.scrollHeight+'px';
            requestAnimationFrame(function(){op.style.height='0px'});
            o.classList.remove('is-open');
            o.querySelector('.tf-q__b').setAttribute('aria-expanded','false');
          });
        }
        if(open){
          pan.style.height=pan.scrollHeight+'px';
          requestAnimationFrame(function(){pan.style.height='0px'});
          q.classList.remove('is-open');
          btn.setAttribute('aria-expanded','false');
        }else{
          pan.style.height=pan.scrollHeight+'px';
          q.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
          pan.addEventListener('transitionend',function h(){pan.style.height='auto';pan.removeEventListener('transitionend',h)});
        }
      });
    });
  }

  function header(){
    var h=document.getElementById('tfHeader');
    if(!h||h.getAttribute('data-tf-ready'))return;
    h.setAttribute('data-tf-ready','1');
    var sp=document.getElementById('tfSpacer');
    var bar=h.querySelector('.tf-hd__bar');
    var transparent=h.getAttribute('data-transparent')==='true';

    function size(){
      var full=h.offsetHeight;
      var barH=bar?bar.offsetHeight:full;
      if(sp)sp.style.height=full+'px';
      document.body.style.setProperty('--tf-hd-h',full+'px');
      document.body.style.setProperty('--header-height',barH+'px');
      document.body.style.setProperty('--header-group-height',full+'px');
      document.body.style.setProperty('--top-row-height',barH+'px');
      document.body.style.setProperty('--transparent-header-offset-boolean','0');
    }

    function onScroll(){
      var y=window.pageYOffset||document.documentElement.scrollTop;
      if(y>24){h.classList.add('is-scrolled');if(transparent)h.classList.add('is-solid')}
      else{h.classList.remove('is-scrolled');if(transparent)h.classList.remove('is-solid')}
      size();
    }

    size();onScroll();
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',size);

    var b=document.getElementById('tfBurger'),m=document.getElementById('tfMenu'),x=document.getElementById('tfMenuX');
    if(m){
      var openMenu=function(){m.classList.add('is-open');m.setAttribute('aria-hidden','false');if(b)b.setAttribute('aria-expanded','true');document.body.classList.add('tf-lock')};
      var closeMenu=function(){m.classList.remove('is-open');m.setAttribute('aria-hidden','true');if(b)b.setAttribute('aria-expanded','false');document.body.classList.remove('tf-lock')};
      if(b)b.addEventListener('click',openMenu);
      if(x)x.addEventListener('click',closeMenu);
      document.addEventListener('keydown',function(e){if(e.key==='Escape'||e.key==='Esc')closeMenu()});
    }

    // Hide the fixed header while a theme dialog (cart drawer / search) is open,
    // so its close button stays reachable.
    var watch=['cart-drawer','search-modal'];
    watch.forEach(function(id){
      var el=document.getElementById(id);
      if(!el)return;
      var mo=new MutationObserver(function(){
        var open=el.hasAttribute('open')||el.getAttribute('aria-hidden')==='false'||el.classList.contains('is-open');
        h.classList.toggle('tf-hd--behind',!!open);
      });
      mo.observe(el,{attributes:true,attributeFilter:['open','aria-hidden','class']});
    });
  }

  function init(root){reveal(root);faq(root);header()}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init()})}else{init()}
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
